var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChatStyleConversational(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 80,
    rx: 4,
    fill: "#4F4C57"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 120,
    height: 28,
    rx: 6,
    fill: "#625E70"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 18,
    y: 16,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#908CA0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 16,
    width: 37,
    height: 4,
    rx: 2,
    fill: "#908CA0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 22,
    width: 84,
    height: 4,
    rx: 2,
    fill: "#908CA0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 28,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#908CA0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 42,
    width: 101,
    height: 28,
    rx: 6,
    fill: "#625E70"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 18,
    y: 48,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#908CA0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 48,
    width: 37,
    height: 4,
    rx: 2,
    fill: "#908CA0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 54,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#908CA0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 60,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#908CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatStyleConversational);
export default __webpack_public_path__ + "static/media/icon-chat-style-conversational.cfa79d5ad06ab0d5602609366b811273.svg";
export { ForwardRef as ReactComponent };